export default "__VITE_ASSET__Bqc$RvRh__"